<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">send</mat-icon></div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Transmitir NF-e</h2>
    <span class="modal-subtitle">{{ data.subtitulo }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" [disabled]="isTransmitindo"
      (click)="fechar()" aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

@switch (etapa) {
@case (etapaEnum.Inicio) {
<mat-dialog-content class="modal-content">
  <p class="dialog-instruction">
    A nota será enviada para a SEFAZ e não poderá ser alterada até o retorno. O resultado aparece na listagem de notas fiscais.
  </p>

  @if (isHomologacao) {
  <app-alert-card type="warning" icon="science" title="Ambiente de homologação">
    A nota é transmitida em homologação: serve para testes e não tem valor fiscal.
  </app-alert-card>
  }

  @if (isCarregandoCertificado) {
  <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
  } @else if (statusCertificado === statusCertificadoEnum.Valido) {
  <app-alert-card type="success" icon="verified" title="Certificado digital válido">
    @if (dataVencimentoCertificado) {
    O certificado A1 da empresa vale até {{ dataVencimentoCertificado | datetimeEmpresa:'dd/MM/yyyy' }}.
    } @else {
    O certificado A1 da empresa está válido.
    }
  </app-alert-card>
  } @else if (isCertificadoComAviso) {
  <app-alert-card type="warning" icon="warning" title="Certificado digital perto do vencimento">
    O certificado A1 da empresa vence em {{ dataVencimentoCertificado | datetimeEmpresa:'dd/MM/yyyy' }}. Renove para não interromper a emissão.
  </app-alert-card>
  } @else if (statusCertificado === statusCertificadoEnum.Vencido) {
  <app-alert-card type="error" icon="error" title="Certificado digital vencido">
    O certificado A1 da empresa venceu em {{ dataVencimentoCertificado | datetimeEmpresa:'dd/MM/yyyy' }}. A SEFAZ não autoriza a nota até a
    renovação do certificado em Configurações de notas fiscais.
  </app-alert-card>
  } @else if (statusCertificado === statusCertificadoEnum.NaoConfigurado) {
  <app-alert-card type="error" icon="error" title="Certificado digital não cadastrado">
    A empresa não tem certificado A1 cadastrado. A SEFAZ não autoriza a nota sem ele; cadastre o certificado em Configurações de
    notas fiscais.
  </app-alert-card>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isTransmitindo" (click)="fechar()">Cancelar</button>
  <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isTransmitindo"
    [disabled]="isTransmitindo" [attr.aria-label]="isTransmitindo ? 'Transmitindo' : 'Transmitir'" (click)="transmitir()">
    <mat-icon class="material-symbols-outlined">send</mat-icon>
    Transmitir
    @if (isTransmitindo) { <mat-spinner diameter="20"></mat-spinner> }
  </button>
</mat-dialog-actions>
}

@case (etapaEnum.Recusa) {
<mat-dialog-content class="modal-content">
  <p class="dialog-instruction">Não é possível transmitir: a nota tem pendências. Corrija os itens abaixo para transmitir.</p>
  <ul class="lista-pendencia">
    @for (pendencia of listaPendencia; track $index) {
    <li>{{ pendencia }}</li>
    }
  </ul>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Fechar</button>
  <button mat-flat-button type="button" class="btn-primary" (click)="corrigir()">
    <mat-icon class="material-symbols-outlined">edit</mat-icon>
    Corrigir
  </button>
</mat-dialog-actions>
}

@case (etapaEnum.Transmitindo) {
<mat-dialog-content class="modal-content transmitindo-content">
  <img src="assets/gifs/processando.gif" alt="" class="transmitindo-gif" />
  <h3 class="transmitindo-titulo">Transmitindo</h3>
  <p class="transmitindo-texto">A nota foi enviada para a SEFAZ. Acompanhe o resultado pela listagem.</p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-flat-button type="button" class="btn-primary" (click)="concluir()">{{ rotuloBotaoFinal }}</button>
</mat-dialog-actions>
}
}
